import React from 'react';
import Header from './header/Header';
import { Props } from './question.type';

function Question({ currentStep, data }: Props) {
  const { question, total } = data;
  return (
    <div className="border-end h-100 user-select-none">
      <Header currentStep={currentStep} total={total} />
      <section>
        <p>{question?.question}</p>
      </section>
    </div>
  );
}

export default Question;
